import { IAppConfig, IAppConfigRaw } from '~/shared/types'

export const getAppConfigFromConfigRaw = (
  config: IAppConfigRaw,
): IAppConfig => ({
  amplitudeApiKey: config.amplitude_api_key,
  firebaseConfig: config.firebase_config,
  giaApiKeys: config.gia_api_keys,
  cookiesConsentCountries: config.cookies_consent_countries || [],
})
